// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const CircleWhiteChevronDown = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.458.125c5.454 0 9.875 4.421 9.875 9.875s-4.421 9.875-9.875 9.875S.583 15.454.583 10 5.004.125 10.458.125ZM15.482 7c-.363 0-.68.17-.904.433l-4.005 4.226-3.945-4.163C6.405 7.201 6.073 7 5.685 7c-.678 0-1.227.575-1.227 1.286 0 .356.14.677.362.91l4.92 5.187c.22.225.514.367.843.367.324 0 .614-.14.832-.358l4.92-5.188c.228-.233.373-.557.373-.918 0-.711-.549-1.286-1.226-1.286Z"
			fill="#fff"
		/>
	</svg>
);
export default CircleWhiteChevronDown;
